export default "__VITE_ASSET__t3e$nc2m__"